import { loadData } from "./localStorage";

const PRODUCT = process.env.REACT_APP_PRODUCT;
export const IS_REGISTRATION_FLOW = ["NUCLEUS", "ABANTE", "AC", "BRIGADE", "AMWAJ"].includes(PRODUCT);
export const SHOW_REGISTRATION_PAGE = !["NUCLEUS", "ABANTE", "AC", "BRIGADE", "AMWAJ"].includes(PRODUCT);
export const SHOW_STEPPER_FLOW = loadData('show_stepper_flow')
